import React, { useEffect } from "react";
import Login from "../components/login";
import { Image } from "antd";
import LoginSider from "../assets/img/loginSliderNew.png";
import logo from "../assets/img/logo.svg";
import { Flex } from "antd";
import { postApiWithoutRedirect } from "../services/api";
import { useNavigate, Link } from "react-router-dom";
import useWindowSize from '../hooks/useWindowSize';

const LoginPage = () => {
  const navigate = useNavigate();
  const isMobile = useWindowSize();

  useEffect(() => {
    validateToken();
  }, []);

  const validateToken = () => {
    if (localStorage.getItem("token")) {
      postApiWithoutRedirect("/auth/token/validate")
        .then(() => {
          navigate("/dashboard");
        })
        .catch((ex) => {
          console.error("Invalid token");
        });
    }
  };

  return (
    <Flex style={{ minHeight: "100vh" }}>
      <div
        style={{
          flex: "1.2",
          background: `url(${LoginSider}) no-repeat center center`,
          backgroundSize: "cover",
          height: "100vh",
          display: isMobile ? 'none' : 'block'
        }}
      ></div>

      <Flex
        style={{
          flex: isMobile ? '1' : '0.8',
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          padding: isMobile ? "20px" : "40px",
          position: "relative",
          backgroundColor: "#fff"
        }}
      >
        <div style={{ maxWidth: "400px", width: "100%" }}>
          <Image 
            preview={false} 
            src={logo} 
            style={{ 
              width: "162px",
              height: "100px",
              marginBottom: "10px",
              position: "relative",
              left: "-24px"
            }}
          />
          <h2 
            style={{ 
              color: "#08184F",
              fontSize: "24px",
              marginBottom: "8px",
              fontWeight: 700,
              lineHeight: "20px",
              letterSpacing: "0%"
            }}
          >
            Sign in to your account
          </h2>
          <p style={{ 
            marginBottom: "24px", 
            fontSize: "14px",
            color: "#666" 
          }}>
            Not a member?{" "}
            <Link to="/register" style={{ 
              color: "#08184F",
              fontWeight: "bold"
            }}>
              Request access
            </Link>
          </p>
          <Login />
        </div>

        <div
          style={{
            position: "absolute",
            bottom: "20px",
            width: "100%",
            textAlign: "center",
            color: "#666",
            fontSize: "14px"
          }}
        >
          © {new Date().getFullYear()} Orlando Magic
        </div>
      </Flex>
    </Flex>
  );
};

export default LoginPage;
